import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const API_URL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        checkAuthStatus();
    }, []);

    const checkAuthStatus = async () => {
        try {
            const token = localStorage.getItem('voxipro_token');
            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                const response = await axios.post(`${API_URL}/api/auth/verify`);
                if (response.data.valid) {
                    setUser({ username: response.data.user });
                } else {
                    localStorage.removeItem('voxipro_token');
                    delete axios.defaults.headers.common['Authorization'];
                }
            }
        } catch (error) {
            console.error('Auth check failed:', error);
            localStorage.removeItem('voxipro_token');
            delete axios.defaults.headers.common['Authorization'];
        } finally {
            setLoading(false);
        }
    };

    const login = async (credentials) => {
        try {
            const response = await axios.post(`${API_URL}/api/auth/login`, credentials);
            const { access_token, user } = response.data;

            localStorage.setItem('voxipro_token', access_token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

            setUser(user);
            return { success: true };
        } catch (error) {
            console.error('Login failed:', error);
            return {
                success: false,
                error: error.response?.data?.detail || 'Erreur de connexion'
            };
        }
    };

    const logout = () => {
        localStorage.removeItem('voxipro_token');
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
    };

    const getCaptcha = async () => {
        try {
            const response = await axios.post(`${API_URL}/api/auth/captcha`);
            return response.data;
        } catch (error) {
            console.error('Captcha generation failed:', error);
            throw error;
        }
    };

    const value = {
        user,
        loading,
        login,
        logout,
        getCaptcha,
        isAuthenticated: !!user
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};